import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../Service/Baseservice";
import UploadIcon from "../../Assets/img/upload.png";
import CharIcon from "../../Assets/img/word.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useParams, useLocation } from "react-router-dom";
import OurServicesPreview from "./OurServicesPreview";

const ServicesAdd = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const lang = queryParams.get("lang");

  const languageId = lang ? Number(lang) : 1;
  const [showPreviewOurService, setShowPreviewOurService] = useState(false);
  const [previewData, setPreviewData] = useState(null);

  const [formData, setFormData] = useState({
    language_id: "",
    ourservice_id: "",
    heading: "",
    image: "",
    order_by:"",
    description: "",
    requirements: "",
    createdBy: "1",
    updatedBy: "1",
  });
  useEffect(() => {
    if (!id) return;

    API.post("ourserviceListView/condition", {
      ourservice_id: id,
      language_id: languageId
    })

      .then((res) => {
        console.log("OUR SERVICE RESPONSE = ", res.data);

        const ourservice = res.data?.data?.ourservice;

        setFormData((prev) => ({
          ...prev,
          ourservice_id: id,
          language_id: ourservice?.language_id || languageId,
        }));
      })
      .catch(() => {
        console.error("Failed to load service details");
      });

  }, [id]);


  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadedUrl, setUploadedUrl] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  const [popup, setPopup] = useState({ show: false, title: "", message: "", type: "info" });

  const getPlainTextLength = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return (div.textContent || "").length;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = () => {
    if (!formData.heading || !formData.description || !formData.requirements || !imageFile) {
      setPopup({ show: true, title: "Warning", message: "Please fill all required fields", type: "info" });
      return;
    }
    setIsSubmitting(true);
  };

  useEffect(() => {
    if (isSubmitting && imageFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imagePayload = {
          name: imageFile.name,
          image: [
            {
              name: imageFile.name,
              type: imageFile.type,
              size: `${imageFile.size} bytes`,
              base64: reader.result,
            },
          ],
        };

        setLoading(true);

        API.post("imageUpload/add", imagePayload)
          .then((res) => setUploadedUrl(res.data?.url))
          .catch(() => {
            setPopup({ show: true, title: "Error", message: "Image upload failed", type: "failed" });
            setIsSubmitting(false);
            setLoading(false);
          });
      };

      reader.readAsDataURL(imageFile);
    }
  }, [isSubmitting, imageFile]);

  useEffect(() => {
    if (uploadedUrl && isSubmitting) {
      const payload = { ...formData, image: uploadedUrl };

      API.post("add_listofservice/add", payload)
        .then(() => {
          setPopup({ show: true, title: "Success", message: "Service added successfully!", type: "success" });
          setTimeout(() => navigate(`/ourservices/${id}?lang=${languageId}`), 2000);
        })
        .catch(() => {
          setPopup({ show: true, title: "Error", message: "Failed to add service", type: "failed" });
        })
        .finally(() => {
          setIsSubmitting(false);
          setLoading(false);
          setUploadedUrl(null);
          setImageFile(null);
        });
    }
  }, [uploadedUrl, isSubmitting]);

  const handlePreview = () => {
    if (!formData.heading || !formData.description || !formData.requirements) {
      setPopup({
        show: true,
        title: "Warning",
        message: "Please fill all required fields to preview",
        type: "info",
      });
      return;
    }

    setPreviewData({
      ...formData,
      listofservice_id: "preview",
      image: imagePreview,
    });
    setShowPreviewOurService(true);
  };
  const MAX_DESC = 4000;
  const MAX_REQ = 1000;

  const [lastValidEditor, setLastValidEditor] = useState({
    description: "",
    requirements: "",
  });
  const handleLimitedEditor = (html, field, editor, max) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || "";

    if (text.length <= max) {
      // save last valid
      setLastValidEditor(prev => ({
        ...prev,
        [field]: html,
      }));

      setFormData(prev => ({
        ...prev,
        [field]: html,
      }));
    } else {
      // restore → blocks typing, allows backspace
      editor.setData(lastValidEditor[field] || "");
    }
  };

  return (
    <div className="newss-containeradd">
      <div className="service-header-bar">
        <h2>Add Services</h2>
        <div className="button-group">
          <button onClick={handlePreview} className="saves-btn">
            Preview
          </button>
          <button onClick={handleSubmit} className="saves-btn">{loading ? "Save" : "Save"}</button>
          <button onClick={() => navigate(`/ourservices/${id}`)} className="cancel-btn ">Back</button>
        </div>
      </div>

      <div className="service-container">
        <div className="left-form">
          <div className="form-group">
            <label className="news-description-label">
              <span className="label-text">Heading <span className="required">*</span></span>
              <div className="char-wrapper"><img src={CharIcon} /><span className="char-count">{getPlainTextLength(formData.heading)}/50</span></div>
            </label>
            <input type="text" name="heading" value={formData.heading} onChange={handleChange} placeholder="Enter heading" maxLength={50} />
          </div>

          <div className="upload-section">
            <label>Upload Image <span className="required">*</span></label>
            <div className="service-upload-box">
              {imagePreview ? <img src={imagePreview} className="preview-img" /> : <><img src={UploadIcon} className="upload-icon" /><p>Click to upload</p></>}
              <input type="file" accept="image/*" onChange={handleImageUpload} />
            </div>
          </div>
        </div>

        <div className="serviceadd-right-section">
          <div className="news-form-group ouradd-editor-small">
            <label className="news-description-label">
              <span className="label-text">Description <span className="required">*</span></span>
              <div className="char-wrapper"><img src={CharIcon} /><span className="char-count">{getPlainTextLength(formData.description)}/4000</span></div>
            </label>

            <CKEditor
              editor={ClassicEditor}
              data={formData.description}
              onReady={(editor) =>
                setLastValidEditor(prev => ({
                  ...prev,
                  description: editor.getData(),
                }))
              }
              onChange={(e, editor) =>
                handleLimitedEditor(
                  editor.getData(),
                  "description",
                  editor,
                  MAX_DESC
                )
              }
              config={{
                toolbar: [
                  "undo", "redo", "|",
                  "heading", "|",
                  "bold", "italic", "underline", "|",
                  "bulletedList", "numberedList",
                ],
              }}
            />

          </div>

          <div className="news-form-group ouradd-editor-small">
            <label className="news-description-label">
              <span className="label-text">Requirements <span className="required">*</span></span>
              <div className="char-wrapper"><img src={CharIcon} /><span className="char-count">{getPlainTextLength(formData.requirements)}/1000</span></div>
            </label>

            <CKEditor
              editor={ClassicEditor}
              data={formData.requirements}
              onReady={(editor) =>
                setLastValidEditor(prev => ({
                  ...prev,
                  requirements: editor.getData(),
                }))
              }
              onChange={(e, editor) =>
                handleLimitedEditor(
                  editor.getData(),
                  "requirements",
                  editor,
                  MAX_REQ
                )
              }
              config={{
                toolbar: [
                  "undo", "redo", "|",
                  "heading", "|",
                  "bold", "italic", "underline", "|",
                  "bulletedList", "numberedList",
                ],
              }}
            />

          </div>
        </div>
      </div>
      {showPreviewOurService && (
        <OurServicesPreview
          previewService={previewData}
          setShowPreviewOurService={setShowPreviewOurService}
        />
      )}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box popup-${popup.type}`}>
            <h3>{popup.title}</h3>
            <p>{popup.message}</p>
            <button className="btn ok-btn" onClick={() => setPopup({ ...popup, show: false })}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesAdd;
